import { getToken } from "firebase/messaging";
import { initFirebase } from "./firebase";
import API from "../api/api";

export const registerNotificationToken = async (
    userId,
    role,
    userName,
    isRegistration = false
) => {
    try {
        const permission = await Notification.requestPermission();

        if (permission !== "granted") {
            return;
        }

        // ✅ Destructure the newly added 'config' variable
        const { messaging, vapidKey, config } = await initFirebase();
        if (!messaging || !vapidKey) throw new Error("Firebase failed to initialize properly");

        // ✅ Convert the config object into URL parameters
        const queryParams = new URLSearchParams(config).toString();

        // ✅ Append the parameters to the Service Worker URL
        // Use a narrow scope so this doesn't replace the main PWA service worker (sw.js) at root
        const registration = await navigator.serviceWorker.register(
            `/firebase-messaging-sw.js?${queryParams}`,
            { scope: '/firebase-cloud-messaging-push-scope' }
        );

        // Wait max 5 seconds
        await Promise.race([
            navigator.serviceWorker.ready,
            new Promise((_, reject) =>
                setTimeout(() => reject(new Error("Service Worker timeout")), 5000)
            ),
        ]);

        console.log("✅ SERVICE WORKER READY");

        // Wait max 10 seconds for FCM token
        const token = await Promise.race([
            getToken(messaging, {
                vapidKey: vapidKey,
                serviceWorkerRegistration: registration,
            }),
            new Promise((_, reject) =>
                setTimeout(() => reject(new Error("FCM timeout")), 10000)
            ),
        ]);

        if (!token) return;

        await API.post("/notifications/save-token", {
            user_id: userId,
            role,
            token,
        });

        await API.post("/notifications/send-welcome", {
            user_id: userId,
            name: userName,
            is_registration: isRegistration,
        });
    } catch (err) {
        console.error("NOTIFICATION ERROR:", err);
    }
};